import * as Yup from 'yup';

const partnerFormValidationSchema = Yup.object().shape({
  useYn: Yup.boolean().required('사용여부를 선택해주세요.'),
  partnerCtgyCd: Yup.string().required('카테고리를 선택해주세요.'),
  partnerName: Yup.string().required('파트너 이름을 입력해주세요.'),
});

export default partnerFormValidationSchema;
